<ng-container *ngIf="tableFilters">
	<ng-template [ngTemplateOutlet]="tableFilters"></ng-template>
</ng-container>

<ng-container *ngIf="hasFilters && !tableFilters">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-6 col-12">
				<div class="input-group mb-4">
					<ng-container
						*ngIf="!!filters && filters.textSearchRestriction"
					>
						<input
							#inputSearch
							id="{{ filters.textSearchRestriction.id }}"
							[type]="
								getRestrictionType(
									filters.textSearchRestriction
								)
							"
							class="form-control custom-input-filter"
							[placeholder]="
								'GLOBAL.DATATABLE.GLOBAL_SEARCH' | translate
							"
							(keyup.enter)="
								updateFilter(
									filters.textSearchRestriction.id,
									inputSearch.value
								)
							"
						/>

						<app-button
							class="ms-2"
							severity="secondary"
							[isOutline]="true"
							(clickBtn)="toggleShowFilters()"
							icon="bi bi-funnel"
							iconPosition="right"
							>{{
								"GLOBAL.DATATABLE.FILTERS" | translate
							}}</app-button
						></ng-container
					>
				</div>
			</div>
		</div>

		<div class="row" *ngIf="showFilters">
			<div
				class="col-12 mb-2 col-md-4 mb-md-1"
				*ngFor="
					let restriction of filterRestrictions(filters.restrictions)
				"
			>
				<div
					class="search"
					*ngIf="
						restriction.editType !== 'select_list' &&
						restriction.editType !== 'hidden'
					"
				>
					<input
						#inputSearch
						id="{{ restriction.id }}"
						[type]="getRestrictionType(restriction)"
						class="form-control"
						placeholder="{{ restriction.translateKey | translate }}"
						(keyup.enter)="
							updateFilter(restriction.id, inputSearch.value)
						"
					/>
					<span
						class="search-icon"
						(click)="
							updateFilter(
								filters.textSearchRestriction.id,
								inputSearch.value
							)
						"
					></span>
				</div>
				<div
					class="search"
					*ngIf="restriction.editType === 'select_list'"
				>
					<ng-select
						appearance="outline"
						[searchable]="false"
						[clearable]="false"
						labelForId="{{ restriction.id }}"
						placeholder="{{ restriction.translateKey | translate }}"
						(change)="
							updateFilter(
								restriction.id,
								convertToString($event)
							)
						"
					>
						<ng-option
							*ngFor="let select of selectList"
							[value]="select.id"
						>
							{{ select.label }}
						</ng-option>
					</ng-select>
				</div>
			</div>
		</div>
	</div>
</ng-container>

<div class="table-responsive">
	<table #dtTable class="table table-default table-hover">
		<thead>
			<tr *ngIf="!tableHeader">
				<th *ngIf="hasSelection"></th>
				<th
					*ngFor="let column of columns"
					scope="col"
					[ngStyle]="!!column.styleCustom ? column.styleCustom : {}"
				>
					<app-order-column-icon
						[title]="column.title"
						[prop]="column.prop"
					></app-order-column-icon>
				</th>
			</tr>
			<ng-template [ngTemplateOutlet]="tableHeader"></ng-template>
		</thead>
		<tbody>
			<ng-container *ngIf="!tableHeader && columns.length === 0">
				<tr class="text-center">
					<td>Ooops! Não há colunas selecionadas!</td>
				</tr>
			</ng-container>
			<ng-container *ngIf="value.length === 0">
				<tr class="text-center">
					<td colspan="100%">Não há dados a serem exibidos</td>
				</tr>
			</ng-container>
			<ng-container *ngIf="value.length > 0">
				<ng-template
					ngFor
					let-rowData
					let-index="index"
					[ngForOf]="value"
				>
					<ng-container
						*ngTemplateOutlet="
							tableBody;
							context: {
								$implicit: rowData,
								expanded: isRowExpanded(rowData),
								columns: columns,
								index
							}
						"
					></ng-container>
					<ng-container *ngIf="isRowExpanded(rowData)">
						<ng-container
							*ngTemplateOutlet="
								tableRowExpansion;
								context: { $implicit: rowData, index }
							"
						></ng-container>
					</ng-container>
				</ng-template>
			</ng-container>
		</tbody>
		<tfoot>
			<ng-template [ngTemplateOutlet]="tableFooter"></ng-template>
			<ng-container *ngIf="showPagination">
				<tr *ngIf="!tableFooter">
					<td colspan="100%">
						<pagination
							[totalItems]="totalElements"
							[itemsPerPage]="pageSize"
							[boundaryLinks]="true"
							previousText="&lsaquo;"
							nextText="&rsaquo;"
							firstText="&laquo;"
							lastText="&raquo;"
							[maxSize]="5"
							(pageChanged)="pageChanged($event)"
							class="justify-content-end"
						></pagination>
					</td>
				</tr>
			</ng-container>
		</tfoot>
	</table>
</div>
